import { Box } from '@wix/design-system';
import React from 'react';
import { useSessionInfoContext } from '../../../../hooks/use-session-info-context';
import { dataHooks } from '../../../../utils/datahooks';
import { ColorContrastElementGenericContent } from './generic/color-contrast-element-generic-content';
import { ColorContrastIncompleteElementContent } from './incomplete/color-contrast-incomplete-element-content';
import { ColorContrastElementRegularContent } from './regular/color-contrast-element-regular-content';
export const ColorContrastElementContent = _ref => {
  let {
    failedElement,
    onClickCancel,
    onClickApply,
    onChangeElementsColor,
    showLoader,
    elementIndex,
    status,
    isGeneric,
    pageId,
    dataHook
  } = _ref;
  const {
    locale
  } = useSessionInfoContext();
  const {
    minimalRatio,
    isIncomplete
  } = failedElement;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4",
    marginTop: "SP1",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHooks.colorContrastElementContent(dataHook),
    direction: "vertical",
    gap: "SP2"
  }, isIncomplete ? /*#__PURE__*/React.createElement(ColorContrastIncompleteElementContent, {
    elementIndex: elementIndex,
    failedElement: failedElement,
    locale: locale,
    minimalRatio: minimalRatio,
    pageId: pageId,
    showLoader: showLoader,
    status: status,
    onClickApply: onClickApply,
    onClickCancel: onClickCancel
  }) : isGeneric ? /*#__PURE__*/React.createElement(ColorContrastElementGenericContent, {
    elementIndex: elementIndex,
    failedElement: failedElement,
    locale: locale,
    minimalRatio: minimalRatio,
    pageId: pageId,
    showLoader: showLoader,
    status: status,
    onClickApply: onClickApply,
    onClickCancel: onClickCancel
  }) : /*#__PURE__*/React.createElement(ColorContrastElementRegularContent, {
    elementIndex: elementIndex,
    failedElement: failedElement,
    locale: locale,
    minimalRatio: minimalRatio,
    pageId: pageId,
    showLoader: showLoader,
    status: status,
    onChangeElementsColor: onChangeElementsColor,
    onClickApply: onClickApply,
    onClickCancel: onClickCancel
  })));
};
//# sourceMappingURL=color-contrast-element-content.js.map